
const selectBlankBoundaries = function(boundaries, convex, smooth, width ) {
    const key = `.${smooth}.${convex}.${width}`;
    return boundaries[key];
};
export default selectBlankBoundaries;




// WEBPACK FOOTER //
// ./client/app/common/services/boundaries-helpers.js